export default __webpack_public_path__ + "static/media/newYorkGiantsVideo-2x.0548d376.jpg";